import Breadcrumb from "../../Component/Breadcrumb";

function FeeStructure() {
  return (
    <>
      <Breadcrumb>Students / Fee Structure</Breadcrumb>
      <div className="innersec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Fee Structures</h1>
          </div>
          <div className="recommendations-section">
            <div className="recommendations-card shadow-sm  rounded-4 bg-white">
              <ol className="modern-list">
                <li>
                  For the fee payable for this academic year, please refer to
                  the fee sheet attached.
                </li>
                <li>
                  The details of fees for the previous year and current year are
                  attached herewith.
                </li>
                <li>
                  All payments must be made before the date specified in the fee
                  book and the fee must be deposited in Indian Overseas Bank (no
                  cash will be accepted).
                </li>
                <li>
                  Parents will kindly keep the receipts issued to them safely
                  and shall produce them in proof of payment, if needed.
                </li>
                <li>
                  No child will be permitted to begin a new term unless all
                  arrears due on his/her account have been cleared in full
                  before the commencement of the new term.
                </li>
                <li>
                  A student not paying fees on time will have to pay a fine of
                  Rs. 50/- per month in addition to the arrears.
                </li>
                <li>
                  Application processing fee Rs. 300/- is payable at the time of
                  registration (for new students only).
                </li>
                <li>Board charges extra for classes IX–XII will be payable.</li>
                <li>
                  The exam fee is remitted in the first and third installment,
                  and the composite fee is remitted quarterly, in four
                  installments.
                </li>
              </ol>
            </div>
          </div>
          <div className="fees-section ">
            <h2 className="fees-title mb-4">
              Fee Structure for Academic Year 2024–2025
            </h2>

            <div className="row g-4">
              <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fee-card-link">
                  <div className="fees-card shadow-sm p-4 rounded-4 bg-white h-100">
                    <div className="d-flex align-items-center mb-3">
                      <div className="fees-icon me-3">
                        <i className="bi bi-file-earmark-text"></i>
                      </div>
                      <h5 className="fees-heading mb-0">2025–2026</h5>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fee-card-link">
                  <div className="fees-card shadow-sm p-4 rounded-4 bg-white h-100">
                    <div className="d-flex align-items-center mb-3">
                      <div className="fees-icon me-3">
                        <i className="bi bi-file-earmark-text"></i>
                      </div>
                      <h5 className="fees-heading mb-0">2024–2025</h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default FeeStructure;
